import { createContext, useContext, type ComponentType } from "react";

export interface LaboBallProps {
  number: number;
  /** Numéro mis en avant (star du moment) : variante or plein. */
  star?: boolean;
}

/**
 * Boule légère, même balisage que le composant Twig Ball (templates/components/Ball.html.twig,
 * km.css) : lien vers la fiche et `data-mag-num`, que le tiroir de mag_numero_drawer()
 * ouvre par délégation. La star du moment prend la variante `km-b--sig`.
 */
export function LinkBall({ number, star = false }: LaboBallProps) {
  return (
    <a
      href={`/numero/${number}/`}
      data-mag-num={number}
      className={`km-b km-b--sm${star ? " km-b--sig" : ""}`}
      aria-label={`Fiche du numéro ${number}`}
    >
      {number}
    </a>
  );
}

/** Boule des outils Labo : LinkBall dans l'îlot, MiniKenoBall dans l'application (LaboToolPage). */
export const LaboBallContext = createContext<ComponentType<LaboBallProps>>(LinkBall);

export const useLaboBall = () => useContext(LaboBallContext);
